import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import React, { Suspense } from 'react';
import Instructor_Navbar from './Components/Instructor_Dashboard/Instructor_Navbar'
import Dashboard from './Pages/Instructor_Dashboard/Dashboard'
import DashboardSidebar from './Components/Instructor_Dashboard/DashboardSidebar';
import Course_Manager from './Pages/Instructor_Dashboard/Course_Manager';
import Sales_Report from './Pages/Instructor_Dashboard/Sales_Report';
import Payout_Report from './Pages/Instructor_Dashboard/Payout_Report';
import ZoomLive_Settings from './Pages/Instructor_Dashboard/ZoomLive_Settings';
import AddCourse from './Pages/Instructor_Dashboard/AddCourse';


// Lazy loading components
const Home = React.lazy(() => import('./Pages/Home'));
const Courses = React.lazy(() => import('./Pages/Courses'));
const Body = React.lazy(() => import('./Components/HomePage/Body'));
const Contact = React.lazy(() => import('./Components/Footer/Contact'));
const Blog = React.lazy(() => import('./Components/Footer/Blog'));
const About = React.lazy(() => import('./Components/Footer/About'));
const Privacy = React.lazy(() => import('./Components/Footer/Privacy'));
const TermsAndConditions = React.lazy(() => import('./Components/Footer/TermsAndConditions'));
const Faq = React.lazy(() => import('./Components/Footer/Faq'));
const Refund = React.lazy(() => import('./Components/Footer/Refund'));
const CourseInfo = React.lazy(() => import('./Components/Courses/CourseInfo'));
const EducatorProfile = React.lazy(() => import('./Pages/EducatorProfile'));
const AllBlogs = React.lazy(() => import('./Components/Footer/AllBlogs'));
const MyCourses = React.lazy(() => import('./Pages/User/MyCourses'));
const Messages = React.lazy(() => import('./Pages/User/Messages'));
const PurchaseHistory = React.lazy(() => import('./Pages/User/PurchaseHistory'));
const Profile = React.lazy(() => import('./Pages/User/Profile'));
const Account = React.lazy(() => import('./Pages/User/Account'));
const PayoutSettings = React.lazy(() => import('./Pages/User/PayoutSettings'));
const Wishlist = React.lazy(() => import('./Pages/User/Wishlist'));
const Login = React.lazy(() => import('./Pages/Auth/Login'));
const Signup = React.lazy(() => import('./Pages/Auth/Signup'));
const ForgotPassword = React.lazy(() => import('./Pages/Auth/ForgotPassword'));


function App() {
  return (
    <div>
      <BrowserRouter>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path='/' element={<Home />}>
              <Route path='/' element={<Body />} />
              <Route path='/courses' element={<Courses />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/blog' element={<Blog />} />
              <Route path='/about' element={<About />} />
              <Route path='/privacy_policy' element={<Privacy />} />
              <Route path='/terms_and_conditions' element={<TermsAndConditions />} />
              <Route path='/faq' element={<Faq />} />
              <Route path='/refund_and_policy' element={<Refund />} />
              <Route path='/courses/course/:course_name/:id' element={<CourseInfo />} />
              <Route path='/educator_profile' element={<EducatorProfile />} />
              <Route path='/blogs' element={<AllBlogs />} />
              <Route path='/course/search' element={<Courses />} />
              <Route path='/home/my_courses' element={<MyCourses />} />
              <Route path='/home/message' element={<Messages />} />
              <Route path='/home/purchase_history' element={<PurchaseHistory />} />
              <Route path='/home/profile' element={<Profile />} />
              <Route path='/home/user_credentials' element={<Account />} />
              <Route path='/home/payout_settings' element={<PayoutSettings />} />
              <Route path='/home/wishlist' element={<Wishlist />} />
              <Route path='/login' element={<Login />} />
              <Route path='/signup' element={<Signup />} />
              <Route path='/forgot_password' element={<ForgotPassword />} />
            </Route>

            
               <Route path='/user' element={<DashboardSidebar />}>
                 <Route path='/user/dashboard' element={<Dashboard />} />
                 <Route path='/user/course_manager' element={<Course_Manager />} />
                 <Route path='/user/sales_report' element={<Sales_Report />} />
                 <Route path='/user/payout_report' element={<Payout_Report />} />
                 <Route path='/user/zoom_live_settings' element={<ZoomLive_Settings />} />
                 <Route path='/user/add_course' element={<AddCourse/>} />
                 <Route path='/user/edit_course' element={<AddCourse/>} />
               </Route>
           
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
